export enum ProductViews {
  ALL,
  SHORTAGE,
  BACK_IN_STOCK,
  NOVELTIES,
  SORTALYS,
  ORDERS,
  EXPECTED_STOCK_OUT,
}

export enum ProductViewNames {
  ALL = 'PRODUCT.VIEWS.ALL',
  SHORTAGE = 'PRODUCT.VIEWS.REPORTED_SHORTAGES',
  BACK_IN_STOCK = 'PRODUCT.VIEWS.BACK_IN_STOCK',
  NOVELTIES = 'PRODUCT.VIEWS.NOVELTIES',
  SORTALYS = 'PRODUCT.VIEWS.SORTALYS',
  ORDERS = 'PRODUCT.VIEWS.ORDERS',
  EXPECTED_STOCK_OUT = 'PRODUCT.VIEWS.EXPECTED_STOCK_OUT',
}

export enum BackendViewNames {
  ALL = 'all',
  SHORTAGE = 'reported_shortages',
  BACK_IN_STOCK = 'back_in_stock',
  NOVELTIES = 'novelties',
  SORTALYS = 'sortalys',
  ORDERS = 'orders',
  EXPECTED_STOCK_OUT = 'expected_shortages',
}

export const productViewToTabNameMap = new Map<ProductViews, BackendViewNames>([
  [ProductViews.ALL, BackendViewNames.ALL],
  [ProductViews.SHORTAGE, BackendViewNames.SHORTAGE],
  [ProductViews.BACK_IN_STOCK, BackendViewNames.BACK_IN_STOCK],
  [ProductViews.NOVELTIES, BackendViewNames.NOVELTIES],
  [ProductViews.SORTALYS, BackendViewNames.SORTALYS],
  [ProductViews.ORDERS, BackendViewNames.ORDERS],
  [ProductViews.EXPECTED_STOCK_OUT, BackendViewNames.EXPECTED_STOCK_OUT],
]);

export const tabNameToProductViewMap = new Map<BackendViewNames, ProductViews>([
  [BackendViewNames.ALL, ProductViews.ALL],
  [BackendViewNames.SHORTAGE, ProductViews.SHORTAGE],
  [BackendViewNames.BACK_IN_STOCK, ProductViews.BACK_IN_STOCK],
  [BackendViewNames.NOVELTIES, ProductViews.NOVELTIES],
  [BackendViewNames.SORTALYS, ProductViews.SORTALYS],
  [BackendViewNames.ORDERS, ProductViews.ORDERS],
  [BackendViewNames.EXPECTED_STOCK_OUT, ProductViews.EXPECTED_STOCK_OUT],
]);
